import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { UpdateUserInput } from '@/__generated__/graphql.ts';
import { gql } from '@/__generated__/index.ts';

const UPDATE_BACKGROUND_IMAGE = gql(`
  mutation UpdateBackgroundImage($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      backgroundImage {
        key
      }
    }
  }
`);

export const useUpdateBackgroundImage = () => {
  const toast = useToast();

  const [updateBackgroundImageMutation, result] = useMutation(
    UPDATE_BACKGROUND_IMAGE,
    {
      onCompleted() {
        toast.info({
          title: 'Background image successfully updated',
        });
      },
      onError() {
        toast.error({
          title: 'Failed to update background image',
          subTitle: 'Please try again',
        });
      },
    },
  );

  const updateBackgroundImage = (input: UpdateUserInput) => {
    updateBackgroundImageMutation({
      variables: {
        input,
      },
    });
  };

  return [updateBackgroundImage, result] as const;
};
